// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i6-0";
export var actionModalContentContainer = "_i6-1";
export var createTagButton = "_i6-2";
export var footerContainer = "_i6-7";
export var fullWidthDivider = "_i6-3";
export var hasCreateTagButton = "_i6-4";
export var noCreateTagButton = "_i6-5";
export var tagsContainer = "_i6-6";
export var tagsModalContentContainer = "_i6-8";